/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexVariantRequestDto } from '../../models/backend-opex-variant-request-dto';
import { BackendOpexVariantResponseDto } from '../../models/backend-opex-variant-response-dto';

export interface OpexesVariantsCreate$Params {
  body: BackendOpexVariantRequestDto;
}

export function opexesVariantsCreate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesVariantsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOpexVariantResponseDto>> {
  const rb = new RequestBuilder(rootUrl, opexesVariantsCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOpexVariantResponseDto>;
    }),
  );
}

opexesVariantsCreate.PATH = '/api/opexes/variants/';
